import { useContext, useEffect, useState } from "react";
import Title from "../Title/Title";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { LangContext } from "../../../Context/LangContext";
import "./Packages.css";
import axios from "axios";
import { PACKAGES, baseURL } from "../../../Api/Api";



function PackagesDetails(props) {
  const langCtx = useContext(LangContext);
  return (
    <Col lg={4}>
      <div className="sub-packages">
        <h3>{props.name}</h3>
        <div className="number-packages">
          <h2 className="border-white">
            <span> {props.num} </span> <img src="/images/H.png" alt="#" />
          </h2>
        </div>
        <div className="price-packages">
          <h2>{props.price}</h2>
          <span>{text.currency[langCtx]} </span>
        </div>
        <h4> {text.features[langCtx]} </h4>
        <ul>
          {props.features}
        </ul>
      </div>
    </Col>
  );
}

export default function Packages() {
  const langCtx = useContext(LangContext);

  const [dataPackages, setdataPackages] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}/${PACKAGES}`, {
        headers: {
          Accept: "application/json",
          "Accept-Language": `${langCtx}`,
        },
      })
      .then((res) => setdataPackages(res.data.data));
  }, [langCtx]);

  const taPackages = dataPackages.map((item) => {
    return (
      <PackagesDetails
        key={item.id}
        id={item.id}
        num={item.month}
        name={item.title}
        price={item.i_price}
        features={item.advantage.map((advantageItem, index) => (
          <li key={index}><img src="/images/tec.png" alt="tec" />  {advantageItem}</li>
        ))}
      />
    );
  });

  return (
    <section id="packages" className="packages mr-section pg-section">
      <div className="main-container">
        <Title name={text.TitlePackages[langCtx]} center />
        <div className="main-packages mt-5">
          <Row style={{rowGap:'15px'}}>{taPackages}</Row>
        </div>
      </div>
    </section>
  );
}

const text = {
  TitlePackages: {
    ar: "باقات الاشتراك ",
    en: "Subscription packages",
  },
  features: {
    ar: " من مميزات الباقة الآتي  ",
    en: "Among the features of the package are the following",
  },

  currency: {
    ar: " ريال سعودي  ",
    en: "SR",
  },
};
